import { render, staticRenderFns } from "./CRM.vue?vue&type=template&id=0a20812d&scoped=true&"
var script = {}
import style0 from "./CRM.vue?vue&type=style&index=0&id=0a20812d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20812d",
  null
  
)

export default component.exports